import { Dayjs } from 'dayjs';
import { useEffect, useState } from 'react';
import StaffHTTPService from 'services/HTTPService/staff/StaffHTTPService';
import { useAppQuery } from 'services/reactQuery/useAppQuery';
import { JournalId } from 'types';
import { parseDayjsDateIntoString } from 'utils/parsers/dateTime/parseDayjsDateIntoString';

type SpecialJournalTopicEditPageNetworkManageProps = {
    journalId: JournalId;
    initialTopicDate?: string;
};

export const useSpecialJournalTopicEditPageNetworkManage = ({
    journalId,
    initialTopicDate,
}: SpecialJournalTopicEditPageNetworkManageProps) => {
    const [selectedFormTopicDate, setSelectedFormTopicDate] = useState<string | undefined>(
        initialTopicDate,
    );

    const handleSelectFormTopicDate = (date: Dayjs | null) => {
        if (date) {
            const parsedDate = parseDayjsDateIntoString(date, 'YYYY-MM-DD');
            setSelectedFormTopicDate(parsedDate);
            return;
        }
        setSelectedFormTopicDate(undefined);
    };

    useEffect(() => {
        if (initialTopicDate) {
            setSelectedFormTopicDate(initialTopicDate);
        }
    }, [initialTopicDate]);

    const filters = {
        date: selectedFormTopicDate || '',
        journalId,
    };

    const {
        data: specialLessonsData,
        isFetching: isSpecialLessonsDataFetching,
        isError: isSpecialLessonsDataError,
    } = useAppQuery(
        'LESSONS_WITHOUT_TOPIC',
        [journalId, selectedFormTopicDate],
        () => StaffHTTPService.employeeSchedule.getLessonsWithoutTopic(filters),
        {
            enabled: !!selectedFormTopicDate,
        },
    );

    return {
        specialLessonsData,
        isSpecialLessonsDataFetching,
        isSpecialLessonsDataError,
        handleSelectFormTopicDate,
    };
};
